import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { List } from "antd";
import Styles from "./Styles";
import { apiBasicAuthGetEventAction, apiBasicAuthGetMastCode } from "../../api/api";
import { isEmpty } from "../../utils/comm";
import ReactPlayer from "react-player";
import { getDefaultProps } from "../../api/client";
import "./Alaram.css";
import moment from "moment";

function Alarm() {
  let params = useParams();
  // 미디어 정보
  const [eventData, setEventData] = useState([{ serialNo: null, znNm: null, updateDt: null, fileNm: null }]);
  const [data, setData] = useState([{ updateDt: "", excSn: "", evtTp: "", evtNm: "" }]);

  // 이벤트 상황 목록 조회
  function callEventActionList(evtId) {
    const model = {
      siteId: sessionStorage.getItem("siteId"),
      evtId: evtId,
    };

    try {
      apiBasicAuthGetMastCode("EVT").then((evtCdData) => {
        apiBasicAuthGetEventAction(model).then((response) => {
          if (response.data.code === 0 || response.data.code === 10) {
            if (!isEmpty(response.data.data)) {
              let vData = response.data.data.filter((vItem) => vItem.mediaTp === "v");
              setEventData(vData);

              const updateDt = vData[0].createDt ? moment(vData[0].createDt).format("YYYY-MM-DD HH:mm:ss") : "";
              const excSn = isEmpty(vData[0].equSn)
                ? ""
                : isEmpty(vData[0].equNo)
                ? vData[0].equSn
                : vData[0].equSn + "(" + vData[0].equNo + ")";

              const evtTp = vData[0].evtTp;
              let evtNm = "";

              evtCdData.map((data) => {
                if (data.code === evtTp) {
                  evtNm = data.codeNm;
                }
              });

              setData({
                updateDt: updateDt,
                excSn: excSn,
                evtNm: evtNm,
              });
            }
          }
        });
      });
    } catch (e) {}
  }

  useEffect(() => {
    const encEvtId = params.evtId;

    // 복호화
    let code = new Map([
      ["a", "1"],
      ["b", "2"],
      ["c", "3"],
      ["d", "4"],
      ["e", "5"],
      ["f", "6"],
      ["g", "7"],
      ["h", "8"],
      ["i", "9"],
      ["j", "0"],
    ]);

    let evtId = "";
    if (encEvtId.length > 0) {
      const charArr = Object.assign([], encEvtId);
      charArr.forEach((char, i) => {
        evtId += code.get(char);
      });
    }

    callEventActionList(evtId);
  }, []);

  return (
    <Styles>
      <div style={{ margin: "35px 45px" }}>
        <div style={{ margin: "auto" }}>
          <div style={{ display: "flex" }}>
            <p style={{ marginRight: "auto" }}>발생 일시</p>
            <p style={{ marginLeft: "auto" }}>{data.updateDt}</p>
          </div>
          <div style={{ display: "flex" }}>
            <p style={{ marginRight: "auto" }}>장비 ID</p>
            <p style={{ marginLeft: "auto" }}>{data.excSn}</p>
          </div>
          <div style={{ display: "flex" }}>
            <p style={{ marginRight: "auto" }}>감지 이벤트</p>
            <p style={{ marginLeft: "auto" }}>{data.evtNm}</p>
          </div>
          <div style={{ width: "100%" }}>
            <List
              // itemLayout="horizontal"
              dataSource={eventData}
              renderItem={(item) => {
                return (
                  <List.Item>
                    <ReactPlayer
                      width={"100%"}
                      height={"100%"}
                      url={item.fileNm ? getDefaultProps("fileUrl") + item.fileNm : ""}
                      controls={true}
                      playing={false}
                    />
                  </List.Item>
                );
              }}
            />
          </div>
        </div>
      </div>
    </Styles>
  );
}

export default Alarm;
